import {FC} from 'react';

interface Props {
  fill?: string;
  size?: number;
}

export const MailIcon: FC<Props> = ({fill = '#000', size = 48}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.356 19.42a.4.4 0 01.644.312v13.58a3.188 3.188 0 01-3.188 3.188H10.189A3.188 3.188 0 017 33.312V19.74c0-.332.379-.518.644-.312 1.488 1.155 3.46 2.623 10.233 7.544 1.402 1.022 3.766 3.174 6.123 3.16 2.37.02 4.781-2.177 6.13-3.16 6.773-4.921 8.738-6.395 10.226-7.55zM24 28c1.54.027 3.759-1.94 4.874-2.75 8.812-6.394 9.483-6.952 11.515-8.546A1.59 1.59 0 0041 15.45v-1.261A3.188 3.188 0 0037.812 11H10.189A3.188 3.188 0 007 14.188v1.261c0 .492.226.95.61 1.255 2.033 1.587 2.704 2.152 11.516 8.547C20.24 26.06 22.459 28.027 24 28z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
};

export default MailIcon;
